import { axiosObject } from "../config";

export default function getAllProperties(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/properties/_read";
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
